import {
  AutoCompleteInputProps,
  AutoCompleteListProps,
  AutoCompleteCreatable as ChakraAutoCompleteCreatable,
  AutoCompleteInput as ChakraAutoCompleteInput,
  AutoCompleteItem as ChakraAutoCompleteItem,
  AutoCompleteList as ChakraAutoCompleteList,
  AutoComplete as ChakraAutoCompleteRoot,
} from '@choc-ui/chakra-autocomplete';
import { forwardRef } from 'react';

const AutoCompleteContent = forwardRef<HTMLDivElement, AutoCompleteListProps>(
  (props, ref) => (
    <ChakraAutoCompleteList background="white" ref={ref} {...props} />
  )
);
const AutoCompleteInput = forwardRef<HTMLInputElement, AutoCompleteInputProps>(
  (props, ref) => (
    <ChakraAutoCompleteInput
      background="white"
      border="1px solid"
      borderColor="gray.400"
      focusRing="mixed"
      focusRingColor="blue.500"
      focusRingWidth="1px"
      ref={ref}
      {...props}
    />
  )
);

// TODO: Move away from choc-ui/chakra-autocomplete to Chakra v3 once ComboBox is available there
const ComboBox = {
  Content: AutoCompleteContent,
  Creatable: ChakraAutoCompleteCreatable,
  Input: AutoCompleteInput,
  Item: ChakraAutoCompleteItem,
  Root: ChakraAutoCompleteRoot,
};

export default ComboBox;
